import * as React from "react";
import PropTypes from "prop-types";

// components
import RegisteredEventCard from "./registeredCard";

// Material
import { Card, CardMedia, Typography, Box, Grid, CircularProgress, Tooltip, Button } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";

// Utils
import { getOrdinalNumber } from "@/utils/date";
import { ONLINE } from "@/store/actions/registeredEventsActions";

// Styles
import { useStyles } from "./style";

export default function EventCard({
    coverImage,
    title,
    location,
    dateTimeIsoFormat,
    registerButton,
    onClickTitle,
    desktopCardWidth,
    raised,
    registrationFee,
    loading,
    registered,
    eventType,
    uniqueId,
    slotTime,
}) {
    const classes = useStyles({ desktopCardWidth, loading });

    const eventDateTime = new Date(dateTimeIsoFormat);
    const time = eventDateTime.toLocaleTimeString("en", {
        timeStyle: "short",
        hour12: true,
    });
    var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const date = loading
        ? ""
        : `${days[eventDateTime.getDay()]} , ${getOrdinalNumber(
              eventDateTime.getDate()
          )} ${eventDateTime.toLocaleString("default", {
              month: "short",
          })} ${eventDateTime.getFullYear()}`;

    const eliptedTitle = (title) => {
        if (title.length > 40) {
            return `${title.substring(0, 40)}...`;
        }
        return title;
    };

    const showEventType = () => {
        if (eventType)
            return (
                <span style={{ textTransform: "capitalize" }}>
                    {" |"}
                    <Box display={"inline-flex"} alignItems="center" justifyContent={"center"}>
                        {eventType.toLowerCase() === ONLINE ? (
                            <Box className={`${classes.dot} ${classes.success}`} />
                        ) : (
                            <Box className={`${classes.dot} ${classes.grey}`} />
                        )}
                    </Box>
                    {eventType}
                </span>
            );
        return "";
    };

    if (registered) {
        return (
            <RegisteredEventCard
                coverImage={coverImage}
                dateTimeIsoFormat={dateTimeIsoFormat}
                location={location}
                onClickTitle={registerButton.onClick}
                title={title}
                desktopCardWidth="100%"
                eventType={eventType}
                uniqueId={uniqueId}
                slotTime={slotTime}
                button={registerButton}
            />
        );
    }

    return (
        <Card raised={raised} className={classes.containerCard}>
            <Box className={classes.root}>
                {loading ? (
                    <Box className={classes.media}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <CardMedia className={classes.media} image={coverImage.src} title={coverImage.alt} />
                )}
                <Box className={classes.cardContent}>
                    <div className={classes.titleContainer}>
                        <Typography
                            className={classes.title}
                            gutterBottom
                            onClick={loading ? null : onClickTitle}
                            variant="h2"
                        >
                            {loading ? (
                                <Skeleton />
                            ) : (
                                <Tooltip title={title} variant={"body1"}>
                                    <span>{eliptedTitle(title)}</span>
                                </Tooltip>
                            )}
                        </Typography>
                    </div>
                    <div className={classes.details}>
                        <Grid container>
                            <Grid item xs={10}>
                                <Typography color="primary" variant="h3" className={classes.date}>
                                    {loading ? <Skeleton className={classes.dateLoader} /> : date}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Typography variant="subtitle1" className={classes.otherDetails}>
                            {loading ? (
                                <Skeleton className={classes.otherDetailsLoader} />
                            ) : (
                                <>
                                    {`${location} | ${time}`} {showEventType()}
                                </>
                            )}
                            {loading ? "" : registrationFee && ` | ${registrationFee}`}
                        </Typography>
                    </div>
                </Box>
            </Box>
            <Box py={1} px={2}>
                {loading ? (
                    <Box>
                        <Skeleton className={classes.buttonLoader} />
                    </Box>
                ) : (
                    <div className={classes.actionContainer}>
                        <Button
                            onClick={registerButton.onClick}
                            variant="outlined"
                            color={registered ? "primary" : "inherit"}
                            fullWidth={true}
                            disabled={loading}
                        >
                            {registerButton.label}
                        </Button>
                    </div>
                )}
            </Box>
        </Card>
    );
}

EventCard.propTypes = {
    coverImage: PropTypes.object,
    title: PropTypes.string,
    location: PropTypes.string,
    dateTimeIsoFormat: PropTypes.string,
    registerButton: PropTypes.object,
    onClickTitle: PropTypes.func.isRequired,
    desktopCardWidth: PropTypes.string,
    raised: PropTypes.bool,
    registrationFee: PropTypes.string,
    loading: PropTypes.bool,
    registered: PropTypes.bool,
    eventType: PropTypes.string,
    uniqueId: PropTypes.string,
    slotTime: PropTypes.string,
};

EventCard.defaultProps = {
    raised: false,
    registrationFee: "",
    loading: false,
};
